import {
  FieldDef,
  formatAmount,
  formatDate,
  formatDollarAmount,
  formatEnergyAmount,
} from "@synota-io/synota-shared-ui";
import { IServiceChargeInvoice } from "../../../../api/hooks/useServiceChargeInvoices";

export const serviceChargeInvoiceFields: FieldDef<IServiceChargeInvoice>[] = [
  {
    field: "contract_name",
    headerName: "Contract",
    flex: 1,
    type: "string",
  },
  {
    field: "counterparty_name",
    headerName: "Counterparty",
    flex: 1,
    type: "string",
  },
  {
    field: "utility_service_id",
    headerName: "Utility Service ID",
    flex: 1,
    type: "string",
  },
  {
    field: "invoice_number",
    headerName: "Invoice Number",
    flex: 1,
    headerAlign: "right",
    align: "right",
  },
  {
    field: "settlement_start_date",
    headerName: "Settlement Period Start",
    flex: 1,
    type: "number",
    valueFormatter: (value) => formatDate(value),
  },
  {
    field: "usage_amount",
    headerName: "Usage Amount (kWh)",
    flex: 1,
    type: "number",
    valueFormatter: formatEnergyAmount,
  },
  {
    field: "service_charge_counterparty_name",
    headerName: "Payer",
    flex: 1,
    type: "string",
  },
  {
    field: "service_charge_number",
    headerName: "Service Charge ID",
    width: 60,
    flex: 1,
    headerAlign: "right",
    align: "right",
  },
  {
    field: "charge_description",
    headerName: "Rate Description",
    flex: 1,
    maxWidth: 220,
    type: "string",
  },
  {
    field: "rate",
    headerName: "Rate ($/MWh)",
    flex: 1,
    type: "number",
    valueFormatter: (value) => formatAmount(value * 1000, 3),
  },
  {
    field: "charge_amount",
    headerName: "Service Charge Amount",
    flex: 1,
    type: "number",
    valueFormatter: (value) => formatDollarAmount(value),
  },
  {
    field: "payment_status",
    headerName: "Service Charge Payment Status",
    flex: 1,
    type: "string",
  },
  {
    field: "payment_id",
    headerName: "Payment ID",
    flex: 1,
    align: "left",
    headerAlign: "left",
  },
];
